// extracted by mini-css-extract-plugin
export var Logo = "s_N";
export var angleSvg = "s_Q";
export var aniBgLoading = "s_f";
export var aniSpin = "s_d";
export var isInverse = "s_R";
export var rightSvg = "s_P";